import React from 'react'


import Navbar from '../components/navbar'
import Feature from '../components/feature'
import AboutOne from '../components/about-one'
import Client from '../components/client'
import Blog from '../components/blog'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import HomeBanner from '../components/home-banner'
import CounterTwo from '../components/counter-two'
import CtaTwo from '../components/cta-two'
import Project from '../components/project'
import Team from '../components/team'
import clientImg from '../assets/images/report-analysis-5-18.svg'

export default function Index() {
  return (
    <>
    <Navbar/>
    
    <HomeBanner/>

    <section className="section overflow-hidden">
        <div className="container">
            <Feature/>
        </div>

        <div className="container mt-100 mt-60">
            <AboutOne/>
        </div>
        <CounterTwo/>
        
    </section>

    <CtaTwo/>

    <section className="section">
        <div className="container">
            <div className="row align-lg-items-center mb-4 pb-2">
                <div className="col-lg-6 col-md-5">
                    <div className="section-title text-md-start text-center">
                        <h4 className="title mb-3 mb-md-0">Showcase your <br/> Stunning Projects</h4>
                    </div>
                </div>
                
                <div className="col-lg-6 col-md-7">
                    <div className="text-md-start text-center">
                        <p className="text-muted para-desc mx-auto mb-0">Design better and spend less time without restricting creative freedom. Combine layouts, customize everything.</p>
                    </div>
                </div>
            </div>

            <Project/>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Our Minds</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Design better and spend less time without restricting creative freedom. Combine layouts, customize everything.</p>
                    </div>
                </div>
            </div>

            <Team/>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <div className="position-relative">
                        <img src={clientImg} className="img-fluid" alt=""/>

                        <div className="modern-app-round round-small"></div>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0">
                    <div className="section-title ms-lg-3">
                        <h4 className="title mb-3">Customer's Review</h4>
                        <p className="text-muted para-desc mb-0">Design better and spend less time without restricting creative freedom. Combine layouts, customize everything.</p>
                    
                        <Client/>
                    </div>
                </div>
            </div>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="section-title text-center mb-4 pb-2">
                        <h4 className="title mb-3">Blog Or News</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Design better and spend less time without restricting creative freedom. Combine layouts, customize everything.</p>
                    </div>
                </div>
            </div>

            <Blog/>
        </div>
    </section>
        

    <Footer/>

    <ScrollToTop/>
    </>
  )
}
